(ns frontend.ui.component.lp-portal.report.body.innovestor.holding.web
  (:require
   [common.util :as cu]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.component.block-table.view :as block-table]
   [frontend.ui.component.lp-portal.report.component.image.view :as image]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :as vertical-table]
   [frontend.ui.component.lp-portal.voima-components.badge.view :as badge]
   [frontend.ui.component.lp-portal.voima-components.chart-card.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.voima-components.section.style :as style]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.table.view :as table]
   [herb.core :refer [<class]]))

(defn heading-row
  [holding-name]
  [:div
   [:div
    {:style {:display     :flex
             :justify-content :space-between
             :align-items :flex-end
             :gap         :16px}}
    [:div
     {:style {:display   :inline-flex
              :max-width :200px}}
     [:div {:class (<class style/holding-header)} holding-name]]
    [:div
     {:style {:padding-top :16px}}
     [badge/badge
      {:variant :portfolio-company
       :pill?   false}
      "Portfolio company"]]]])

(defn overview-card
  [{:keys [company-information investment-information]}
   props]
  [grid/row {}
   [grid/column {:large 6}
    [table/editable-table company-information props
     (block-table/table "" company-information (merge props {:hide-footnote? true}))]]
   [grid/column {:large 6}
    [table/editable-table investment-information props
     [block-table/table "" investment-information (merge props {:hide-footnote? true})]]]])

(defn company-section
  [ui-data props]
  (let [{:keys [holding-name status-and-events exit-strategy holding-image]} ui-data]
    [section/portfolio-section
     [heading-row holding-name]
     (str "company-section-"
          (some->> props
                   :report
                   :db/id))
     [:div {:class (<class style/section-wrapper)}
      [overview-card ui-data props]
      [grid/row {}
       [grid/column {:large 6}
        [free-text-card/free-text-section "" status-and-events props]
        [image/image (if (cu/blank-value? (:image holding-image)) "Add image (optional)" "") holding-image props false]]
       [grid/column {:large 6}
        [free-text-card/free-text-section "" exit-strategy props]]]]]))


(defn technology-holding-section
  [ui-data props]
  (let [{:keys [holding-name status-and-events financial-performance-chart financial-performance-table]} ui-data]
    [section/portfolio-section
     [heading-row holding-name]
     (str "company-section-"
          (some->> props
                   :report
                   :db/id))
     [:div {:class (<class style/section-wrapper)}
      [overview-card ui-data props]
      [grid/row {}
       [grid/column {:large 6}
        [chart-card/view "Financial performance" financial-performance-chart (merge props {:hide-footnote? true})]
        [table/editable-table financial-performance-table props
         [vertical-table/table "" financial-performance-table props]]]
       [grid/column {:large 6}
        [free-text-card/free-text-section "" status-and-events props]]]]]))

(defn view
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [:div
    [company-section holding-ui-data props]]])

(defn technology-holding-view
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [:div
    [technology-holding-section holding-ui-data props]]])
